// extracted by mini-css-extract-plugin
module.exports = {"inspect":"inspect___u6cW5","wrapper":"wrapper___cyKhP","form__control":"form__control___2SYzB","form":"form___3Q7sF","form__label":"form__label___2U1Tm"};